import { useEffect, useState } from "react";
import { findAllOrderListGroupDeparturesByClientEvent, findAllOrderListGroupDeparturesByClientFilterEvent } from "../../_events/order_list_view/find.event";
import { message } from "antd";
import { useQuery } from "../../_utils/url_query_hook";

export const useDepartureClient = () => {

    const [ loading, setLoading ] = useState(false);
    const [ data, setData ] = useState([]);
    const [ filter, setFilter ] = useState('');
    const query = useQuery();

    const dynamicLoad = () => {
        if(filter !== '' && filter !== null){
            loadFilter();
        } else {
            load();
        }
    }

    const loadFilter = () => {
        setLoading(true);
        findAllOrderListGroupDeparturesByClientFilterEvent(query.get('client'), filter)
        .then(json => {
            setLoading(false);
            setData(json.list);
        })
        .catch(err => {
            setLoading(false);
            message.error(err.message);
        });
    }

    const load = () => {
        setLoading(true);
        findAllOrderListGroupDeparturesByClientEvent(query.get('client'))
        .then(json => {
            setLoading(false);
            setData(json.list);
        })
        .catch(err => {
            setLoading(false);
            message.error(err.message);
        });
    }

    useEffect(() => {
        load();
    }, []);
    
    return {
        data, loading, filter, setFilter, dynamicLoad
    };
}